<template>
    <svg width="100%" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g>
            <defs>
                <linearGradient id="gr-simple2">
                    <stop stop-color="red" offset="0%"/>
                    <stop stop-color="red" :offset="offset + '%'"/>
                    <stop stop-color="green" :offset="offset + '%'"/>
                    <stop stop-color="green" offset="100%"/>
                </linearGradient>
            </defs>
            <text text-anchor="middle" x="50%" y="50%" dy=".35em" class="text2">SVG</text>
        </g>
    </svg>
</template>
<script>
    export default{
        data(){
            return {
                offset:0,
                speed:true
            }
        },
        mounted(){
            let t = setInterval(() => {
                if(this.speed){
                    this.offset += 1;
                    if(this.offset === 100){
                        this.speed = !this.speed
                    }
                }else{
                    this.offset -= 1;
                    if(this.offset === 0){
                        this.speed = !this.speed
                    }
                }
            },16)
        }
    }
</script>
<style>
    .text2 {
      font: 3em Open Sans, Impact;
      text-transform: uppercase;
      fill: url(#gr-simple2);
    }
</style>


// WEBPACK FOOTER //
// src/components/main-content/svg/svg3.vue